import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteBuyTagProps extends ModalEditComponentProps { }

const ModalDeleteBuyTag: React.FC<ModalDeleteBuyTagProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/buy/tag/deleteBuyTag',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteTagQuote', '¿Seguro que quieres eliminar esta etiqueta de presupuesto?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteBuyTag